//import MarkerCard from "./MarkerCard";
import MarkerCardComp from "./MarkerCardComp";
import { useTranslation } from "../../../../language";
import { Grid, Typography, Divider, Box } from "@mui/material";

export default function SectionLabvisitGroups({
  system,
  subsystems,
  selectedDate,
  userId
}) {
  const { t } = useTranslation();

  const systemLabels = {
    metabolic_health: t("systemMetabolic"),
    organ_health: t("systemOrgan"),
    micronutrients: t("systemNutrient"),
    immune_health: t("systemImmune"),
  };

  const subsystemLabels = {
    1: t("subsystemSugar"),
    2: t("subsystemFat"),
    3: t("subsystemLiver"),
    4: t("subsystemKidney"),
    5: t("subsystemPancreas"),
    6: t("subsystemMuscles"),
    7: t("subsystemNonOrgan"),
    13: t("subsystemOxygen"),
    8: t("subsystemFatVit"),
    9: t("subsystemWaterVit"),
    10: t("subsystemMinMicro"),
    11: t("subsystemMinMacro"),
    12: t("subsystemAcute"),
    14: t("subsystemRepair"),
    15: t("subsystemWhite"),
    16: t("subsystemGrano"),
    17: t("subsystemLympho"),
    18: t("subsystemMono"),
    19: t("subsystemInsulin"),
    20: t("subsystemLipoa"),
    21: t("subsystemCvd"),
    22: t("subsystemEnergy"),
    23: t("subsystemHormSter"),
    24: t("subsystemHormProt"),
    25: t("subsystemBoneBreak"),
    26: t("subsystemBoneMin"),
    27: t("subsystemVitWater"),
    28: t("subsystemVitFat"),
    29: t("subsystemTrace"),
    30: t("subsystemThyrFunc"),
    31: t("subsystemThyrReg"),
    32: t("subsystemAmh"),
    33: t("subsystemPsa"),
    34: t("subsystemFattyTotal"),
    35: t("subsystemPUFA"),
    36: t("subsystemOmega3"),
    37: t("subsystemOmega6"),
    38: t("subsystemMUFA"),
    39: t("subsystemSFA"),
  };

  const getSubsystemLabel = (sub) =>
    subsystemLabels[sub] || `Group ${sub}`;

  return (
    <Grid container mt={4} sx={{ mb: 0.5 }}>

      {/* SUBSYSTEMS */}
      {Object.entries(subsystems).map(([subsystem, markerList]) => (
        <Grid size={12} key={subsystem}>
          <Typography
            variant="subtitle2"
            textAlign="center"
            sx={{ fontWeight: 600, my: 2 }}
          >
            {getSubsystemLabel(subsystem)}
          </Typography>

          {/* MARKERS (sorted by order already) */}
          {markerList.map((marker, i) => (
            <Grid
              size={12}
              key={`${marker.id || marker.short}-${i}`}
              sx={{
                mb: 1,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <MarkerCardComp marker={marker} userId={userId} />

            </Grid>
          ))}
        </Grid>
      ))}
    </Grid>
  );
}

{/* SYSTEM HEADER - not used - only subsystem headers

      <Grid size={12}>
        <Typography
          variant="subtitle1"
          textAlign="center"
          sx={{ fontWeight: 700, my: 2 }}
        >
          {systemLabels[system] || system}
        </Typography>

        <Typography
          variant="subtitle2"
          textAlign="center"
          sx={{ opacity: 0.7 }}
        >
          Labvisit: {selectedDate}
        </Typography>
      </Grid>

*/}